import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';

import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';

import {Grid, Switch, Typography, withStyles} from "@material-ui/core";


import Filters from "./Filters";
import {connect} from "react-redux";
// import {EnhancedTableHead} from "../../components/EnhancedTableHead";
import {createData, getComparator, getSiteName, stableSort} from "../../utils/tableUtils";
import AddNew from "../../components/Popups/AddNew";
import {
    addClients,
    changePlan,
    getClients,
    getSites,
    lockCaptcha,
    lockClients,
    removeClients
} from "../../services/clientsService";
import {MuiThemeProvider} from "material-ui";

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Select from "../../components/Select";

import Http from "../../Http";
import {STAT_ROUTES} from "../../config/routes";
import TableHead from "@material-ui/core/TableHead";
import {
    convertTZ,
    decodeEntities,
    formattedDate,
    getStateFromLocalStorage,
    setStateToLocalStorage
} from "../../utils/functions";
import AlertMessage from "../../components/AlertMessage";


const StyledTableRow = withStyles((theme) => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.action.hover,
        // },
        '&:hover': {
            cursor: 'pointer'
        }
    },
}))(TableRow);

function EnhancedTableHead() {
    return (
        <TableHead>
            <StyledTableRow>
                <TableCell align={'center'}>{'ID анкеты'}</TableCell>
                <TableCell align={'center'}>{'Дата'}</TableCell>
                <TableCell align={'center'}>{'Сайт'}</TableCell>
                <TableCell align={'center'}>{'Общее время работы'}</TableCell>
                <TableCell align={'center'}>{'Количество отправленных'}</TableCell>
            </StyledTableRow>
        </TableHead>
    );
}

const styles = theme => ({
    root: {
        width: '100%',

    },
    sec: {
        color: theme.palette.secondary.main
    },
    prim: {
        color: theme.palette.primary.main
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    button: {
        color: '#fff',
        marginLeft: '10px',
        marginBottom: '10px',
        width: '200px'
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    },
    disabledSwitch: {

    }
});

class StatByDay extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            rowPerPage: 10,
            page: 1,
        }
    }
    
    handleChangePage = (event, newPage) => {
        const {rowPerPage, page} = this.state;
        this.setState({page: newPage});
    };

    handleChangeRowsPerPage = (event) => {
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        this.setState({
            rowPerPage: event,
            page: 1
        })
    };
    
    getFormattedTime = (mins) => {
        let days = Math.floor(mins / (60 * 24))
        let hours = Math.floor((mins - days * 24 * 60) / 60)
        let minutes = mins - hours * 60 - days * 24 * 60
        return (
            
                <span><b style={{fontSize: '18px'}}>{days}</b> дней <b style={{fontSize: '18px'}}>{hours}</b> часов <b
                style={{fontSize: '18px'}}>{minutes}</b> минут</span>
        )
    }

    getFormattedTimeWrapped = (mins) => {
        
        return (
            <TableCell align="center">
                {this.getFormattedTime(mins)}
            </TableCell>
        )
    }

    getSliced = (clients) => {
        const {rowPerPage, page} = this.state;
        return rowPerPage !== 'ВСЕ' ? clients.slice((page - 1) * rowPerPage, (page - 1) * rowPerPage + rowPerPage) : clients
    }
    
    
    

    render() {
        const {rowPerPage, page, order, orderBy, displayType, clientId} = this.state;
        const {classes, data} = this.props;

        let statData = this.getSliced(data);
        return (
            <div className={classes.root}>
                
                <Paper component={'div'} className={classes.paper}>


                    <TableContainer>
                        <Table
                            stickyHeader
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                page={page}
                                rowCount={statData.length}
                            />

                            <TableBody>
                                {statData
                                    .map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (

                                            <StyledTableRow
                                                tabIndex={-1}
                                                key={row.login}
                                            >
                                                <MuiThemeProvider>
                                                    {/*<TableCell component="th" id={labelId} scope="row" align="center" >*/}
                                                    {/*    <Button */}
                                                    {/*        size={'small'} */}
                                                    {/*        variant={'contained'} */}
                                                    {/*        color={'primary'} */}
                                                    {/*        onClick={() => this.setType('direct', row.client_id)}*/}
                                                    {/*        style={{borderRadius: '50px',  color: '#fff'}}*/}
                                                    {/*    >*/}
                                                    {/*        Подробнее*/}
                                                    {/*    </Button>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell component="th" id={labelId} scope="row" align="center" >
                                                        {row.login}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" align="center" >
                                                        {formattedDate(row.date)}
                                                    </TableCell>
                                                    <TableCell align="center" style={{
                                                        color: '#6495ed',
                                                        fontSize: '1rem'
                                                    }}>{row.siteName}</TableCell>
                                                    
                                                    {this.getFormattedTimeWrapped(row.total_time)}
                                                    
                                                    <TableCell align="center">{row.count}</TableCell>
                                                </MuiThemeProvider>
                                            </StyledTableRow>

                                        );
                                    })}

                            </TableBody>

                        </Table>
                    </TableContainer>
                    
                   

                </Paper>
                <Grid container>
                    <Grid item xs={7} sm={7} md={7} lg={7}></Grid>
                    <Grid item xs={5} sm={5} md={5} lg={5} style={{
                        display: 'flex',
                        aligItems: 'center',
                        fontSize: '11px',
                        alignItems: 'center',
                        color: 'gray'
                    }}>
                        <Typography variant={'span'} style={{'marginRight': '10px'}}>
                            Записей на странице
                        </Typography>
                        <Select
                            type={'select'}
                            rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                            borderRadius={'20px 20px'}
                            width={'76px'}
                            onChange={this.handleChangeRowsPerPage}
                        />

                        {rowPerPage !== 'ВСЕ' && <Pagination
                            classes={{selected: classes.selectedPagin}}
                            count={Math.ceil(data.length / rowPerPage)}
                            color="primary"
                            page={page}
                            onChange={this.handleChangePage}
                            size={'large'}/>}
                    </Grid>
                </Grid>
               
            </div>
        );
    }

}


export default withStyles(styles)(StatByDay)